export default "__VITE_PUBLIC_ASSET__d934f723__"